import React from 'react';
import { Navigate } from 'react-router-dom';
import { useStoreContext } from '../../contexts/StoreContext';
import SupplierCatalogPage from '../../pages/supplier/SupplierCatalogPage';
import Skeleton from '../common/Skeleton';
import Container from './Container';

// Catálogo só faz sentido no contexto de uma loja. Sem tenant, redireciona
// pra raiz (LP do Reviter). Com tenant, abre o catálogo da loja.
const CatalogRoute = () => {
  const { isStoreSite, loading } = useStoreContext();

  if (loading) {
    return (
      <Container>
        <div className="py-10">
          <Skeleton variant="block" height={320} />
        </div>
      </Container>
    );
  }

  if (!isStoreSite) return <Navigate to="/" replace />;
  return <SupplierCatalogPage />;
};

export default CatalogRoute;
